export default "__VITE_ASSET__UixdbMEH__"